/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

interface Props {
  name: string;
}
type InputProps = JSX.IntrinsicElements['textarea'] & Props;

export default function Textarea({ name, ...rest }: InputProps) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <textarea ref={inputRef} defaultValue={defaultValue} {...rest} />
      {error && <small style={{ color: 'red' }}>{error}</small>}
    </>
  );
}
